
const data = {
  respuesta:
    [
      {
        id: null,
        name: 'Todas',
        slug: 'todas'
      },
      {
        id: 0,
        name: 'Puesta a disposición',
        slug: 'puesta-a-disposicion'
      },
      {
        id: 2,
        name: 'Descargada',
        slug: 'descargada'
      },
      {
        id: 6,
        name: 'Factura no descargable',
        slug: 'notificacion-no-descargable'
      }
    ],
  blnError: false,
  codError: null,
  msgError: null
}

export default data
